export default "__VITE_ASSET__B2bsZ1OJ__"